import "../../new.scss";
import { useState, useEffect, useContext } from "react";
import { DepositosFormContext } from '../../../context/depositos/DepositosContext';
import { useParams, useNavigate } from 'react-router-dom';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import ImagePreview from "../../../components/preview/imagePreview";
import Inputs from "./configForm/inputs";
import { handleInputChange } from "./helpersForm/formHandlers";
import SucursalesModal from '../../sucursales/sucursalesModal/sucursalesModal';

const IP_ADDRESS = process.env.REACT_APP_URL_BACKEND;

export const Form = ({ title }) => {

  const [form, setForm] = useState({});
  const { postDepositoData, report, patchDepositoData } = useContext(DepositosFormContext);

  const [searchFilter, setSearchFilter] = useState();
  const [searchDescFilter, setSearchDescFilter] = useState('');

  const { id } = useParams();
  const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // imágenes
  const [imageUrlLocal, setImageUrlLocal] = useState(null);
  const [imageUrlServer, setImageUrlServer] = useState(null);
  const [selectViewValue, setSelectViewValue] = useState('vistaImagen');

  const nameData = "depositos";

  // Cargar datos de report para editar
  useEffect(() => {
    if (report) {
      setForm(report);
      setSearchFilter(report?.depo_suc?.id);
      setSearchDescFilter(report?.depo_suc?.nombre);
    }
  }, [report]);

  useEffect(() => {
    setForm((prevForm) => ({
      ...prevForm,
      depo_suc_id: searchFilter 
    }));
  }, [searchFilter]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "selectView") {
      setSelectViewValue(value);

      setForm(prev => ({
        ...prev,
        selectView: value
      }));


      return;
    }

    handleInputChange(
      e,
      setForm,
      Inputs(selectViewValue),
      setErrors,
      form,
      setImageUrlLocal,
      selectViewValue
    );
  };

  const validateForm = () => {
    let formErrors = {};
    Inputs(selectViewValue).forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) formErrors[name] = error;
      }
    });
    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };

  const handleSendData = () => {
    if (!validateForm()) {
      const errorArray = Inputs(selectViewValue).reduce((acc, { name, label }) => {
        if (errors[name]) acc.push(`${label}: ${errors[name]}`);
        return acc;
      }, []);

      if (errorArray.length > 0) openErrorDialog(errorArray);
      return;
    }

    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();

    const formData = new FormData();

    // Cargar campos normales excepto imagen e imagen_maps
    Object.keys(form).forEach(key => {
      if (key === "imagen" || key === "imagen_maps" || key === "selectView") return;
      if (form[key] !== undefined && form[key] !== null) {
        formData.append(key, form[key]);
      }
    });

    // IMAGEN o MAPA segun selectView
    if (form.selectView === "vistaImagen") {
      if (form.imagen) {
        formData.append("imagen", form.imagen);
      }
      formData.append("imagen_maps", ""); // forzar null
    }

    if (form.selectView === "vistaMaps") {
      if (form.imagen_maps) {
        formData.append("imagen_maps", form.imagen_maps);
      }
      formData.append("imagen", ""); // forzar null
    }

    try {
      if (id) {
        await patchDepositoData(id, formData);
      } else {
        await postDepositoData(formData);
      }

      navigate(`/${nameData}`);

    } catch (error) {
      console.error(error);
      openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };
  const closeErrorDialog = () => setIsErrorDialogOpen(false);

  const handleCancel = () => navigate(`/${nameData}`);
  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>

        {/* Vista previa usando el componente ImagePreview 
        {!isSubmitting && (
          <ImagePreview
            title="Vista previa del logo"
            imageUrl={imageUrlLocal || (imageUrlServer && `${IP_ADDRESS}${imageUrlServer}`)}
          />
        )}
*/}
        <div className="bottom">
          <div className="right">
            <form>
              {Inputs(selectViewValue).map((input) => {
                if (input.name === "depo_suc_id") {
                  return (
                    <div className="formInput" key={input.id}>
                      <label>{input.label}</label>
                      <SucursalesModal
                        handleChange={setSearchFilter}
                        handleDescChange={setSearchDescFilter}
                        descSelected={searchDescFilter} 
                      />
                      {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                    </div>
                  );
                } else {
                  return (
                    <FormField
                      key={input.id}
                      input={input}
                      value={form[input.name] || ""}
                      handleInputChange={(e) => handleInputChange(e, setForm, Inputs, setErrors, form)}
                      error={errors[input.name]}
                    />
                  );
                }
              })} </form>
              <FormButtons
                isSubmitting={isSubmitting}
                handleSave={handleSendData}
                handleCancel={handleCancel}
                saveText="Guardar"
                cancelText="Cancelar"
              />
            

            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar este registro?"
            />

            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
